import Typography from "antd/lib/typography";
import Select from "antd/lib/select";
import Button from "antd/lib/button";
import DatePicker from "antd/lib/date-picker";

import styles from "./filters-container.module.css";

const { Option } = Select;
const { RangePicker } = DatePicker;

export default function FiltersContainer({ searchRegion, setSearchRegion, regions, searchStatus, setSearchStatus, handleDateRangeChange, applyFilters }) {
    return (
        <div className={styles.filtersContainer}>
        <div className={styles.filterGroup}>
          <div className={styles.filterItem}>
            <Typography.Text className={styles.filterLabel}>Region</Typography.Text>
            <Select
              style={{ width: 200 }}
              placeholder="Filter by region"
              allowClear
              value={searchRegion}
              onChange={setSearchRegion}
            >
              {regions.map(region => (
                <Option key={region} value={region}>{region}</Option>
              ))}
            </Select>
          </div>

          <div className={styles.filterItem}>
            <Typography.Text className={styles.filterLabel}>Status</Typography.Text>
            <Select
              style={{ width: 200 }}
              placeholder="Filter by status"
              allowClear
              value={searchStatus}
              onChange={setSearchStatus}
            >
              <Option value="sent">Sent</Option>
              <Option value="failed">Failed</Option>
            </Select>
          </div>

          <div className={styles.filterItem}>
            <Typography.Text className={styles.filterLabel}>Date Range</Typography.Text>
            <RangePicker
              style={{ width: 300 }}
              onChange={handleDateRangeChange}
            />
          </div>

          <Button 
            type="primary"
            onClick={applyFilters}
            className={styles.button}
            style={{ backgroundColor: '#034832', borderColor: '#034832' }}
          >
            Apply Filters
          </Button>
        </div>
      </div>
    )
}